import { Component, OnInit } from '@angular/core';
import { MatDialog, Sort } from '@angular/material';
import { Router } from '@angular/router';
import { DBService } from '../../services/db.service';
import { User } from '../../model/user';
import { AuthenticationService } from '../../services/authentication.service';
import { ConfirmDeleteComponent } from '../partials/confirm-delete/confirm-delete.component';
import { InputDataComponent } from '../partials/input-data/input-data.component';
import { Segment } from '../../model/segments';

declare var Materialize: any;
declare var $: any;

@Component({
  selector: 'app-segments',
  templateUrl: './segments.component.html',
  styleUrls: ['./segments.component.css'],
  providers: [DBService, AuthenticationService]
})
export class SegmentsComponent implements OnInit {

  loading: boolean;

  list: Segment[];
  displayList: Segment[];

  searchText: string;

  user: User;

  inputData: string;

  path = '/segments';

  constructor(public dialog: MatDialog, private router: Router, private dbService: DBService, private authService: AuthenticationService) {
    this.searchText = '';

    this.loadData();
  }


  ngOnInit() {
  }

  private loadData() {
    this.displayList = [];
    this.loading = true;

    this.dbService.listWithUIDs<Segment>(this.path)
      .then(list => {
        this.list = list;

        this.onSearchChange(this.searchText);
        this.loading = false;
      })
      .catch(error => console.log(error));
  }

  onSearchChange(searchValue: string ) {
    this.searchText = searchValue.toLowerCase();

    this.displayList = this.list
      .sort((e1, e2) => e1.description.localeCompare(e2.description))
      .filter(item => item.description.toLowerCase().includes(this.searchText));
  }

  sortData(sort: Sort) {
    if (!sort.active || sort.direction == '') {
      return;
    }

    this.displayList = this.displayList.sort((a, b) => {
      const isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.compare(a.description, b.description, isAsc);
        default: return 0;
      }
    });
  }

  private compare(a, b, isAsc) {
    return a.localeCompare(b) * (isAsc ? 1 : -1);
  }


  goToNew() {
    const dialogRef = this.dialog.open(InputDataComponent, {
      height: 'auto',
      width: '600px',
      data: { title: 'Novo Segmento' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmNew(result); }
    });
  }

  confirmNew(result: any) {
    const newData = new Segment();
    newData.description = result;

    this.dbService.insertInList<Segment>(this.path, newData)
      .then(uid => {
        Materialize.toast('Dados cadastrados com sucesso', 2000);
        this.loadData();
        $('#icon_prefix').focus();
      })
      .catch(error => console.log(error));
  }

  openDeleteModal(segment: Segment) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '600px',
      data: { name: segment.description }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmDelete(segment.uid); }
    });
  }

  private confirmDelete(uid: string) {
    this.dbService.remove(this.path, uid)
      .then(() => {
        Materialize.toast('Segmento removido com sucesso', 2000);
        this.loadData();
      })
      .catch(error => console.log(error));
  }

  edit(segment: Segment) {
    const dialogRef = this.dialog.open(InputDataComponent, {
      height: 'auto',
      width: '600px',
      data: { title: 'Editar Segmento', inputData: segment.description }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmEdit(segment.uid, result); }
    });
  }

  private confirmEdit(uid: string, description: string) {
    this.dbService.update(`${this.path}/${uid}`,
      {
        description: description,
      }
    )
    .then(() => {
      Materialize.toast('Dados atualizados com sucesso', 2000);
      this.loadData();
      $('#icon_prefix').focus();
    })
    .catch(error => console.log(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/segments/segments.component.ts